import { Input, FormControl, FormLabel } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';

type Props = {
  userId: string;
  onChangeUserId: (userId: string) => void;
  error: boolean;
};

export const UserIdFormControl = ({ userId, onChangeUserId, error }: Props) => {
  const intl = useIntl();
  return (
    <FormControl isInvalid={error}>
      <FormLabel fontWeight="bold" textTransform="uppercase" fontSize="14px" htmlFor="userId">
        <FormattedMessage id="realm_add_user_header_id" />
      </FormLabel>
      <Input
        id="userId"
        placeholder={intl.formatMessage({ id: 'realm_add_user_placeholder_id' })}
        value={userId}
        onChange={(e) => onChangeUserId(e.target.value)}
      />
    </FormControl>
  );
};
